import React, { useState, Fragment } from 'react';
import Spinner from '../../layout/Spinner';
import { useDispatch, useSelector } from 'react-redux';
import { apiAction } from '../../store/generalSlice';

const initialState = {
  token: process.env.REACT_APP_TOKEN,
  type: 'From Monday.Formrally.com',
  name: '',
  email: '',
  subject: '',
  message: '',
};

const Contact = () => {
  const dispatch = useDispatch();
  const [formData, setFormData] = useState(initialState);
  const [alert, setAlert] = useState(undefined);
  const [loadSend, setLoadSend] = useState(false);

  const { contact } = useSelector((state) => state.general);
  console.log({ contact });
  const onChange = (e) => setFormData({ ...formData, [e.target.name]: e.target.value });
  return (
    <section id='contact' className='contact'>
      <div className='container' data-aos='fade-up'>
        <div className='section-title'>
          <h2 style={{ color: '#1a3f36' }}>Contact</h2>
          <p>
            Interested to talk about our products? Feel free to leave us a message, we’ll get back to you as soon as
            possible.
          </p>
        </div>

        <div className='row'>
          <div className='col-lg-5 d-flex align-items-stretch'>
            <div className='info'>
              <div className='address'>
                <i className='icofont-google-map'></i>
                <h4>Location:</h4>
                <p>Perth, WA 6059, Australia</p>
              </div>

              <div className='email'>
                <i className='icofont-envelope'></i>
                <h4>Email:</h4>
                <p>info@beyondoil.au</p>
              </div>

              {/* <iframe
                title='myFrame'
                src='https://www.google.com/maps/embed/v1/place?q=Kibbutz+Yifat,+3658300,+Israel/@32.677229,35.2192511,1536m/data=!3m2!1e3!4b1!5m1!1e1&key=AIzaSyBFw0Qbyq9zTFTd-tUY6dZWTgaQzuU17R8'
                frameBorder='0'
                style={{ border: '0', width: '100%', height: '290px' }}
                allowFullScreen
              ></iframe> */}
            </div>
          </div>

          <div className='col-lg-7 mt-5 mt-lg-0 d-flex align-items-stretch'>
            <form onSubmit={async (e) => {}} className='php-email-form'>
              <div className='form-row'>
                <div className='form-group col-md-6'>
                  <label htmlFor='name'>Your Name</label>
                  <input
                    type='text'
                    name='name'
                    className='form-control'
                    id='name'
                    data-rule='minlen:4'
                    data-msg='Please enter at least 4 chars'
                    defaultValue={formData.name}
                    placeholder='...'
                    onChange={(e) => onChange(e)}
                  />
                  <div className='validate'></div>
                </div>
                <div className='form-group col-md-6'>
                  <label htmlFor='name'>Your Email</label>
                  <input
                    type='email'
                    className='form-control'
                    name='email'
                    id='email'
                    data-rule='email'
                    data-msg='Please enter a valid email'
                    defaultValue={formData.email}
                    placeholder='example@email.com'
                    onChange={(e) => onChange(e)}
                  />
                  <div className='validate'></div>
                </div>
              </div>
              <div className='form-group'>
                <label htmlFor='name'>Subject</label>
                <input
                  type='text'
                  className='form-control'
                  name='subject'
                  id='subject'
                  data-rule='minlen:4'
                  data-msg='Please enter at least 8 chars of subject'
                  defaultValue={formData.subject}
                  placeholder='How can we help?'
                  onChange={(e) => onChange(e)}
                />
                <div className='validate'></div>
              </div>
              <div className='form-group'>
                <label htmlFor='name'>Message</label>
                <textarea
                  className='form-control'
                  name='message'
                  rows='10'
                  data-rule='required'
                  data-msg='Please write something for us'
                  defaultValue={formData.message}
                  placeholder='Tell us more...'
                  onChange={(e) => onChange(e)}
                ></textarea>
                <div className='validate'></div>
              </div>
              <div className='mb-3'>
                <div className='loading'>Loading</div>
                <div className='error-message'></div>
                <div className='sent-message'>Your message has been sent. Thank you!</div>
              </div>
              <div className='text-center'>
                {!loadSend ? (
                  <Fragment>
                    {formData.email !== '' && formData.subject !== '' && alert !== 'SUCCESS' ? (
                      <button
                        className='btn btn-outline-primary'
                        onClick={(e) => {
                          setAlert('SUCCESS');
                          e.preventDefault();
                          dispatch(apiAction({ reduxField: 'contact', route: 'emailing/sendEmail', formData }));
                        }}
                      >
                        Send Message
                      </button>
                    ) : null}
                  </Fragment>
                ) : (
                  <Spinner />
                )}
                {alert === 'ERROR' ? <p className='text-danger'>Something went wrong</p> : null}
                {alert === 'SUCCESS' ? (
                  <p className='text-success'>Thank you, Message was send. We will contact you soon.</p>
                ) : null}
              </div>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
};

{
  /* <div className='phone'>
<i className='icofont-phone'></i>
<h4>Call:</h4>
<p>+1 5589 55488 55s</p>
</div> */
}

export default Contact;
